import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

import { shopperMarketingApi as api } from 'api/shopperMarketing';

function VoidVendorPromotionModal({ getVendorPromotions, setNotification, setOpen, vendorPromotionID }) {
    const voidVendorPromotion = async () => {
        const res = await api.updateVendorPromotion(vendorPromotionID, { voided: true });
        if (!res.status) {
            setNotification({ level: 'error', text: `Failed to void promotion: ${res.msg}` });
            return;
        }

        setNotification({ text: 'Vendor promotion voided', level: 'success' });
        getVendorPromotions();
        setOpen(false);
    };

    return (
        <Dialog
            open
            onClose={() => {
                setOpen(false);
            }}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Void Promotion</DialogTitle>
            <DialogContent>Are you sure you want to void this promotion?</DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        setOpen(false);
                    }}
                >
                    Cancel
                </Button>
                <Button color="primary" variant="contained" onClick={voidVendorPromotion}>
                    Confirm Void
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export { VoidVendorPromotionModal };
